import { useState, useCallback } from 'react';

const useToggle = (initialValue = false): [boolean, (value?: boolean) => void] => {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback((value?: boolean) => {
    setValue((v) => value ?? !v);
  }, []);

  return [value, toggle];
};

export default useToggle;
